module.exports = __webpack_public_path__ + "static/media/teampay-icon.9d032b7e.png";